import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "../api/endpoint";
import axios from "axios";
import { STATUS_OPTIONS } from "../layout/onboarding/config/tableConfig";

export const usePreBoarding = (filters = {}) => {
  const {
    status = "",
    financierType = "",
    prn = "",
    limit = 10,
    offset = 0,
    enabled = true,
  } = filters;

  const buildQueryString = () => {
    const params = new URLSearchParams();
    params.append("limit", limit.toString());
    params.append("offset", offset.toString());
    if (status) params.append("status", status);
    if (financierType) params.append("financierType", financierType);
    if (prn) params.append("prn", prn);
    return params.toString();
  };

  return useQuery({
    queryKey: ["preOnboarding", status, financierType, prn, limit, offset],
    queryFn: async () => {
      const response = await fetch(
        `${endpoints.getPreOnboardingDriver}?${buildQueryString()}`,
      );

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      return await response.json();
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    keepPreviousData: true,
  });
};

const updatePreOnboardingStatus = async (id, status) => {
  try {
    const { data } = await axios.patch(
      `${endpoints.updatePreOnboardingDriverStatus}/${id}`,
      { status },
    );
    return data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to change status",
    );
  }
};

export const useUpdatePreOnboardingStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, status }) => updatePreOnboardingStatus(id, status),

    onSuccess: (data, variables) => {
      queryClient.setQueryData(["submissions"], (oldData) => {
        if (!oldData) return oldData;

        return {
          ...oldData,
          data: oldData.data.map((item) =>
            item.id === variables.id
              ? { ...item, status: variables.status }
              : item,
          ),
        };
      });
    },
  });
};

export const getStatusColor = (status) => {
  const option = STATUS_OPTIONS.find((opt) => opt.value === status);
  return option?.color || "default";
};

export const getStatusLabel = (status) => {
  const option = STATUS_OPTIONS.find((opt) => opt.value === status);
  return option?.label || status;
};

const getListOfPreOnboardingPRN = async () => {
  const response = await axios.get(endpoints.getListOfOnboardingPRN);
  return response.data?.data || [];
};

export function usePreOnboardingPRNList(options = {}) {
  return useQuery({
    queryKey: ["preOnboardingPRNList"],
    queryFn: getListOfPreOnboardingPRN,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
    enabled: options?.enabled ?? true,
    ...options,
  });
}
